import {
    IOffice,
    IOrderProductChangeDto,
    IOrderType,
    IOrderTypeField,
    IOrderTypeFieldGroup,
    IProductInfo,
    IProductType,
    OrderTypeFieldGroupType,
} from "@lib";
import { FieldControl } from "@core/types/field-controls/field-control";
import { FieldControlFactory } from "@core/types/field-controls/field-control-factory";

export class OrderBlockProductHandler {
    public controls: FieldControl[] = [];

    private office: IOffice | null = null;
    private orderType: IOrderType | null = null;
    private productTypes: IProductType[] = [];
    private fieldGroup: IOrderTypeFieldGroup | null = null;

    public get title(): string {
        return this.fieldGroup?.name ?? "Устройство";
    }

    public get icon(): string {
        return this.fieldGroup?.icon ?? "monitor";
    }

    public init(office: IOffice | null, orderType: IOrderType | null, productTypes: IProductType[]): void {
        this.office = office;
        this.orderType = orderType;
        this.productTypes = productTypes;

        if (!this.office || !this.orderType) {
            return;
        }

        this.fieldGroup = this.orderType.groups.find(g => g.type === OrderTypeFieldGroupType.Product) ?? null;

        this.initControls();
    }

    private initControls(): void {
        this.controls = [];

        const context = {
            locale: this.office?.info?.locale,
            productTypes: this.productTypes,
        };

        for (const field of this.getFields()) {
            const fieldControl = FieldControlFactory.fromField(field, context);
            this.controls.push(fieldControl);
        }
    }

    private getFields(): IOrderTypeField[] {
        return (
            this.fieldGroup?.fields
                .filter(f => !f.hidden)
                .sort((a, b) =>
                    a.sequence !== undefined && b.sequence !== undefined ? a.sequence - b.sequence : -1,
                ) ?? []
        );
    }

    public getDto(): IOrderProductChangeDto {
        const dto: IOrderProductChangeDto = {
            info: {} as IProductInfo,
            custom: {},
        };

        for (const fieldControl of this.controls) {
            const value = fieldControl.value;
            this.populateCustomFieldValue(dto.custom, fieldControl.field, value);
            this.populateStandartFieldValue(dto.info as IProductInfo, fieldControl.field, value);
        }

        return dto;
    }

    private populateCustomFieldValue(custom: any, field: IOrderTypeField, value: any): void {
        if (!field.custom) {
            return;
        }

        // TODO: remove details1
        const id = field.customId ?? field.details1 ?? field.id;
        custom[id] = value;
    }

    private populateStandartFieldValue(info: IProductInfo, field: IOrderTypeField, value: any): void {
        switch (field.id) {
            case "product.type":
                info.type = value;
                return;
            case "product.sku":
                info.sku = value;
                return;
            case "product.name":
                info.name = value;
                return;
            case "product.serial":
                info.serial = value;
                return;
            case "product.suite":
                info.suite = value;
                return;
            case "product.appearance":
                info.appearance = value;
                return;
            case "product.description":
                info.description = value;
                return;
            case "product.brand":
                info.brand = value;
                return;
            case "product.model":
                info.model = value;
                return;
        }
    }

    public clean(): void {
        this.initControls();
    }
}
